import * as types from '@/store/mutationTypes';

export default {
    // Replace the whole store
    [types.INIT_STORE](state, data) {
        this.replaceState(Object.assign(state, data));
    },

    [types.SET_LAST_TENANT](state, data) {
        state.lastTenant = data.lastTenant;
    },

    [types.SET_TENANT](state, data) {
        state.tenant = data.tenant;
    },

    [types.SET_USER](state, data) {
        state.user = data.user;
    },

    [types.SET_CUR_ORDER](state, data) {
        state.curOrder = data.curOrder;
    },

    [types.SET_CUR_ORDER_ITEM](state, data) {
        state.curOrderItem = data.curOrderItem;
    },

    [types.SET_SPLIT_RECEIPT](state, data) {
        state.splitReceipt = data.splitReceipt;
    },

    [types.SET_CUR_UNPAID_ORDERS](state, data) {
        state.curUnpaidOrders = data.curUnpaidOrders;
    },

    [types.SET_PAUSED_ORDER](state, data) {
        state.pausedOrder = data.pausedOrder;
    },

    [types.SET_CUR_TABLE](state, data) {
        state.curTable = data.curTable;
    },

    [types.SET_CUR_GUEST](state, data) {
        state.curGuest = data.curGuest;
    },

    [types.SET_APP_CONFIG](state, data) {
        state.appConfig = data.appConfig;
    },

    [types.SET_DEVICE](state, data) {
        state.device = data.device;
    },

    [types.SET_PRINT_CONFIG](state, data) {
        state.printConfig = data.printConfig;
    },

    [types.SET_IS_ONLINE](state, data) {
        state.isOnline = data.isOnline;
    },

    [types.SET_LOCAL_CONNECTION](state, data) {
        state.localConnection = data.localConnection;
    },

    [types.SET_SYNC_IN_PROGRESS](state, data) {
        state.syncInProgress = data.syncInProgress;
    },

    [types.SET_SYNC_OPTIONS](state, data) {
        state.syncOptions = data.syncOptions;
    },

    [types.SET_WORKING_DAYS](state, data) {
        state.workingDays = data.workingDays;
    },

    [types.SET_UPDATE_PENDING](state, data) {
        state.updatePending = data.updatePending;
    },

    [types.SET_IMPERSONATE](state, data) {
        state.impersonate = data.impersonate;
    },

    [types.SET_INITIALIZED](state, data) {
        state.initialized = data.initialized;
    },

    [types.SET_TRAINING_MODE](state, data) {
        state.trainingMode = data.trainingMode;
    },

    [types.SET_TABLE_MODE](state, data) {
        state.tableMode = data.tableMode;
    },

    [types.SET_TABLE_PERMISSIONS](state, data) {
        state.tablePermissions = data.tablePermissions;
    },

    [types.SET_ACTIVE_PRICELIST](state, data) {
        state.activePricelist = data.activePricelist;
    },

    [types.SET_MODULES](state, data) {
        state.modules = data.modules;
    },

    [types.SET_INTEGRATIONS](state, data) {
        state.integrations = data.integrations;
    },

    [types.SET_PENDING_CARD_PAYMENT](state, data) {
        state.pendingCardPayment = data.pendingCardPayment;
    },

    [types.SET_KDS_SETTINGS](state, data) {
        state.kdsSettings = data.kdsSettings;
    },

    [types.SET_ACTIVE_SECTOR](state, data) {
        state.activeSector = data.activeSector;
    },
};
